<template>
  <div class='col-xs-12'>
    <div class="col-md-12 col-xs-12">
      <label>{{label}}</label>
    </div>
    <div :class="{'col-xs-10' : mutableValue , 'col-xs-12' : !mutableValue}">
      <select v-model="mutableValue" @change='submitBusca()' class="form-control border-input" v-if="label !== 'Categoria'">
        <option v-for='(item,index) of items' :key='`item-${index}`' :value="item.id">{{item[nome]}}</option>
      </select>
      <select v-model="mutableValue" @change='submitBusca()' class="form-control border-input" v-else>
        <option v-for='(item,index) of items' :key='`item-${index}`' :value="item.id">({{item.id}}) - {{item[nome]}}</option>
      </select>
    </div>
    <div class="col-xs-2" v-if='mutableValue != null'>
      <button title='Limpar' @click='clear()' class="btn btn-sm btn-danger btn-icon btn-round btn-outline-danger">
        <i class="fa fa-times"></i>
      </button>
    </div>
  </div>
</template>
<script>
export default {

  model: {
    prop: 'selected',
    event: 'change'
  },

  props: {
    label: String,
    selected: Number,
    nome: String,
    items: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      mutableValue: null
    }
  },

  watch: {
    selected (val) {
      this.mutableValue = val
    }
  },

  mounted () {
    this.mutableValue = this.selected
  },

  methods: {
    submitBusca () {
      this.$emit('change', this.mutableValue)
    },

    clear () {
      this.mutableValue = null
      this.submitBusca()
    }
  }

}
</script>
<style>
  select {
    height: initial !important;
  }
</style>

